import { useEffect } from "react";
import AppRoutes from "./routes/AppRoutes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  useEffect(() => {
    const storedTheme = localStorage.getItem("theme");
    // Explicitly use the stored theme, or fallback to light
    const nextTheme = storedTheme || "light";

    document.documentElement.dataset.theme = nextTheme;
    if (nextTheme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }

    if (!storedTheme) {
      localStorage.setItem("theme", "light");
    }
  }, []);

  return (
    <>
      <AppRoutes />

      {/* ✅ Toast Container (GLOBAL) */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        newestOnTop
        closeOnClick
        pauseOnHover
        theme="colored"
      />
    </>
  );
}

export default App;